import React from "react";
import { Grid, Box, Typography, Paper, Container, Button } from "@mui/material";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const stats = [
  { number: 300, label: "Projects Delivered" },
  { number: 121, label: "Satisfied Clients" },
  { number: 152, label: "Skilled Professionals" },
  { number: 11, label: "Years of Experience" },
];

export default function StatsSection() {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <Box
      sx={{
        py: 10,
        background:
          "url('https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2022/03/counter_bg.jpg') center/cover no-repeat",
        position: "relative",
        color: "#fff",
        display: "flex",
        alignItems: "center",
      }}
      ref={ref}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          sx={{ flexWrap: { xs: "wrap", lg: "nowrap" } }}
        >
          {/* Left column for the text (col-6) */}
          <Grid item size={{ xs: 12, sm: 6, md: 7 }}>
            {/* Content continues here */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Box>
                <Typography
                  variant="subtitle2"
                  className="paraAfter-line"
                  sx={{ color: "var(--primary-yellow)", mb: 1 }}
                >
                  OUR STATS
                </Typography>
                <Typography
                  variant="h1"
                  className="headPara"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    lineHeight: 1.2,
                    color: "#fff",
                  }}
                >
                  Proven Track Record Across the State
                </Typography>
                <Typography
                  variant="body1"
                  color="inherit"
                  sx={{
                    opacity: 0.83,
                    //   maxWidth: "90%",
                  }}
                >
                  Trusted by government bodies, infrastructure developers, and
                  private contractors, we deliver construction materials and
                  logistics solutions at scale. Our experience across highways,
                  residential projects, and large developments reflects our
                  commitment to quality, compliance, and timely execution.
                </Typography>
                {/* BUTTON */}
                <motion.div
                  initial={{ opacity: 0, x: -70 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ duration: 0.7, ease: "easeOut" }}
                >
                  <Box className="statBtn-bg">
                    <Button class="btn-default" role="button">
                      Discover More
                    </Button>
                  </Box>
                </motion.div>
              </Box>
            </motion.div>
          </Grid>
          {/* Right column for the stats boxes (col-6) */}
          <Grid item size={{ xs: 12, sm: 6, md: 5 }}>
            <Grid container spacing={4} sx={{ justifyContent: "end" }}>
              {stats.map((item, index) => (
                <motion.div
                  className="statsCard"
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                >
                  <Paper elevation={2} sx={{ p: 3 }}>
                    <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
                      {inView ? (
                        <CountUp end={item.number} suffix="+" duration={2} />
                      ) : (
                        "0+"
                      )}
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      sx={{
                        opacity: 1,
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#fff",
                        lineHeight: "1.90",
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Paper>
                </motion.div>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
